// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bej_a bia_b bia_va bia_rv bia_rw bia_vu","PanelFooter--link":"bej_b"};